import { useMutation } from '@apollo/client';
 
import DeletePurchaseOrderMutation from '@/graphql/contracts/bulkDeletePurchaseOrder.mutation.gql';

import { BulkDeletePurchaseOrder, BulkDeletePurchaseOrderVariables }
  from '@/graphql/contracts/_generated_/bulkDeletePurchaseOrder.mutation';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

export default function useDeletePurchaseOrder() {
  const [bulkDeletePurchaseOrder, { loading, error }] = useMutation<
  BulkDeletePurchaseOrder,
  BulkDeletePurchaseOrderVariables
  >(DeletePurchaseOrderMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const deletePurchaseOrder = (purchaseOrderIds: string[], successCb?: () => void) => {
    bulkDeletePurchaseOrder({
      variables: { purchaseOrderIds },
      onCompleted: (data) => {
        if (
          data.bulkDeletePurchaseOrder &&
          'errorMessage' in data.bulkDeletePurchaseOrder &&
          data.bulkDeletePurchaseOrder.errorMessage
        ) {
          notificationService.open({
            title: 'Error',
            text: data.bulkDeletePurchaseOrder.errorMessage,
            type: 'danger',
          });
          return;
        } else {
          notificationService.open({
            title: 'Delete Purchase Order',
            text: 'Purchase Order successfully deleted',
            type: 'success',
          });
        }
        if (successCb) {
          successCb();
        }
      },
    });
  };

  return {
    deletePurchaseOrder,
    isLoadingDeletePurchaseOrder: loading,
    errorDeletePurchaseOrders: error,
  } as const;
}
